// EXT-6658: drop-in for @angular/fire/analytics.
import { isPlatformBrowser } from '@angular/common';
import { InjectionToken, PLATFORM_ID, inject } from '@angular/core';
import {
  Analytics as SdkAnalytics,
  logEvent as _logEvent,
} from 'firebase/analytics';
import {
  InitFn,
  provideInstance,
  zoneWrap,
} from '@jfw/angular/shared/firebase';
import { FirebaseApp } from '@jfw/angular/shared/firebase/app';

export * from 'firebase/analytics';

/** Null on the server: Analytics is browser-only, as in AngularFire. */
export const Analytics = new InjectionToken<SdkAnalytics>(
  'jfw.firebase.analytics',
);
export type Analytics = SdkAnalytics;

export const provideAnalytics = (fn: InitFn<SdkAnalytics>) =>
  provideInstance(
    Analytics,
    (injector) =>
      isPlatformBrowser(injector.get(PLATFORM_ID))
        ? fn(injector)
        : (null as unknown as SdkAnalytics),
    () => inject(FirebaseApp),
  );

// logEvent has overloads; the cast keeps them.
export const logEvent = zoneWrap(_logEvent, false) as typeof _logEvent;
